<template>
  <BaseModal
    :model-value="modelValue"
    title="Encounter Note Signed"
    :title-logo="signatureIcon"
    width="520px"
    description="This encounter note has been successfully signed."
    @update:model-value="$emit('update:modelValue', $event)"
    @close="handleClose"
  >
    <template #footer>
      <div class="flex items-center justify-end w-full">
        <NewButton
          type="normal"
          color-type="dark-blue"
          @click="handleClose"
        >
          Done
        </NewButton>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from './BaseModal.vue';
import NewButton from '@/NewLibrary/Button.vue';
import signatureIcon from '@/assets/encounterNotes/signature.svg';

defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'done']);

const handleClose = () => {
  emit('update:modelValue', false);
  emit('done');
};
</script>
